import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { Client } from 'src/app/shared/models/clients/client';
import { ActivatedRoute } from '@angular/router';
import { ClientsApiService } from 'src/app/core/services/api/clients-api.service';
import { Service } from 'src/app/shared/models/services/service';
import { ToastrService } from 'ngx-toastr';
import { countries } from 'src/app/shared/models/countries';
import { cities } from 'src/app/shared/models/cities';
import { Document } from 'src/app/shared/models/documents/document';
import { Note } from 'src/app/shared/models/clients/note';
import { CreateEditNoteComponent } from '../create-edit-note/create-edit-note.component';
import { BankDetail } from 'src/app/shared/models/clients/bankDetail';
import { BankDetailsModalComponent } from '../bank-details-modal/bank-details-modal.component';
import { Contact } from 'src/app/shared/models/clients/contact';
import { ContactModalComponent } from '../contact-modal/contact-modal.component';
import { UploadDocumentModalComponent } from '../upload-document-modal/upload-document-modal.component';
import { CommunicationService } from 'src/app/core/services/communication.service';
import { ClientContract, PaymentPlanEnum } from 'src/app/shared/models/clients/clientContract';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { User, UserRole } from 'src/app/shared/models/users/user';
import { PrintService } from 'src/app/core/services/print.service';


@Component({
  selector: 'app-client-summary',
  templateUrl: './client-summary.component.html',
  styleUrls: ['./client-summary.component.scss']
})
export class ClientSummaryComponent implements OnInit {
  closeResult = '';
  client: Client;
  files: File[] = [];
  services: Service[] = [];
  editForm = null;
  countries = countries;
  cities = cities;
  paymentPlanEnum = PaymentPlanEnum;
  modalRef: NgbModalRef;
  user: User;
  userRole = UserRole;
  contractCopy: ClientContract = new ClientContract();


  @ViewChild('contactModal') contactModal: ContactModalComponent;
  @ViewChild('bankDetailsModal') bankDetailsModal: BankDetailsModalComponent;
  @ViewChild('createEditNoteModal') createEditNoteModal: CreateEditNoteComponent;
  @ViewChild('uploadDocModal') uploadDocModal: UploadDocumentModalComponent;
  @ViewChild('contractModal') contractModal;

  constructor(
    private modalService: NgbModal,
    private apiService: ClientsApiService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private communicationService: CommunicationService,
    private authService: AuthService,
    private printService: PrintService,
  ) {
    this.route.parent.data.subscribe(resolversData => {
      this.client = resolversData.client;
    });

    this.route.data.subscribe(resolverData => {
      this.services = resolverData.services.results;
    });
  }

  ngOnInit(): void {
    this.user = this.authService.user;
  }

  displayForm(content: HTMLElement, form: HTMLElement) {
    this.toggleElements([content, form]);
  }

  dismissEdit(content: HTMLElement, form: HTMLElement) {
    this.toggleElements([content, form]);
  }

  // toggle elements displaying to edit data
  toggleElements(arr: Array<HTMLElement>) {
    arr.forEach(element => {
      element.classList.toggle('d-none');
    });
  }

  // handle the popup
  openCenteredMadal(content, size) {
    this.modalService.open(content, { centered: true, backdropClass: 'client-summary-modal', size });
  }

  onClientDetailUpdate(client: Client, content: HTMLElement, form: HTMLElement) {
    this.spinner.show();
    console.log(client);

    this.apiService.updateClient(client).subscribe(
      c => {
        this.spinner.hide();
        this.toastr.success('Client Details Updated', 'Success!');
        this.toggleElements([form, content]);
        this.client = c;
        this.communicationService.emitChange(c);
      }
    );
  }


  // Active Contract
  editContract() {
    this.contractCopy = Object.assign(new ClientContract(), this.client.contract);
    this.modalRef = this.modalService.open(this.contractModal, { centered: true, size: 'lg' });
  }

  addNewContract() {
    this.contractCopy.clientId = this.client.id;
    this.modalRef = this.modalService.open(this.contractModal, { centered: true, size: 'lg' });
  }

  submitContract(contract: ClientContract) {
    this.spinner.show();
    if (contract.id) {
      this.apiService.updateClientContract(this.client.id, contract).subscribe(
        c => {
          this.client.contract = c;
          this.spinner.hide();
          this.toastr.success('Contract updated', 'Success!');
        }
      )
    } else {
      this.apiService.createClientContract(this.client.id, contract).subscribe(
        c => {
          this.client.contract = c;
          this.spinner.hide();
          this.toastr.success('Contract addedd', 'Success!');
        }
      )
    }
    this.modalRef.close();
  }


  // Primary Contacts
  addNewContact() {
    const contact = new Contact();
    contact.clientId = this.client.id;
    this.contactModal.open(contact);
  }

  editContact(contact: Contact) {
    this.contactModal.open(contact);
  }
  contactSubmit(contact: Contact) {
    let action = '';
    if (this.client.contacts.find(n => contact.id === n.id)) {
      const i = this.client.contacts.findIndex((value, index, array) => value.id === contact.id);
      this.client.contacts[i] = contact;
      action = 'updated';
    } else {
      this.client.contacts.push(contact);
      action = 'created';
    }
    this.contactModal.close();
    this.toastr.success(`Client ${action}`, 'Success!');
  }

  // bank account
  addNewbank() {
    const bankDetail = new BankDetail();
    bankDetail.clientId = this.client.id;
    this.bankDetailsModal.open(bankDetail);
  }

  editbank(bankDetail: BankDetail) {
    this.bankDetailsModal.open(bankDetail);
  }
  bankDetailSubmit(bankDetail: BankDetail) {
    let action = '';
    if (this.client.bankDetails.find(n => bankDetail.id === n.id)) {
      const i = this.client.notes.findIndex((value, index, array) => value.clientId === bankDetail.clientId);
      this.client.bankDetails[i] = bankDetail;
      action = 'updated';
    } else {
      this.client.bankDetails.push(bankDetail);
      action = 'created';
    }
    this.bankDetailsModal.close();
    this.toastr.success(`Bank Account ${action}`, 'Success!');
  }

  // Documents
  addNewDocument() {
    const document = new Document();
    this.uploadDocModal.open(document);
  }

  uploadDocument(document: Document) {
    const action = '';
    this.client.documents.unshift(document);
    this.uploadDocModal.close();
    this.toastr.success('Documents uploaded', 'Success!');
  }

  // Notes
  addNewNote() {
    const note = new Note();
    note.clientId = this.client.id;
    this.createEditNoteModal.open(note);
  }

  editNote(note: Note) {
    this.createEditNoteModal.open(note);
  }

  noteSubmit(note: Note) {
    let action = '';
    if (this.client.notes.find(n => note.id === n.id)) {
      const i = this.client.notes.findIndex((value, index, array) => value.clientId === note.clientId);
      this.client.notes[i] = note;
      action = 'updated';
    } else {
      this.client.notes.push(note);
      action = 'created';
    }
    this.createEditNoteModal.close();
    this.toastr.success(`Note ${action}`, 'Success!');
  }

  addUploadedDocs(e) {
  }

  onPrint() {
    this.printService.data = this.client;
    this.printService.printDocument('client-summary');
  }

}
